<template>
  <div id="share-with-friends">
    <el-dialog title v-model="showModal" size="tiny" custom-class="share-modal" @close="close" :close-on-click-modal="false">
      <div class="share-body">
        <div class="step-txt step1">
          <span>01</span>打开微信，扫描二维码
        </div>
        <div class="step-txt step2">
          <span>02</span>点击分享给好友
        </div>
        <div class="share-code" :style="'background-image:url('+codeUrl+')'"></div>
        <img class="share-phone" src="../../../assets/imgs/insurance-new/insurance-detail-share.gif" height="409" />
        <div
          class="code-txt"
          v-if="env"
          style="top:auto;bottom:20px;color:red;width:auto;left:80px"
        >(测试、开发环境中此二维码无效，仅为展示)</div>
        <div class="code-txt" v-if="product.insurance_product">
          {{product.insurance_product.insurance_name}}
          <div class="tips-box">不展示同业优惠价与办理按钮</div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { env } from '../../../libs/env';

export default {
  name: 'share-with-friends',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    phoneImg: {
      type: String,
      default: '',
    },
    codeUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
      env,
    };
  },
  methods: {
    // 关闭
    close() {
      this.$emit('input', false);
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
#share-with-friends {
  display: flex;
  .tips-box{
    width: 217px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFF8F3;
    border: 1px solid rgba(255, 128, 51, 0.32);
    color: #FF8033;
    font-size: 14px;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    margin-top: 15px;
    height: 44px;
    border-radius: 4px;
    &::after{
      content: "";
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent rgba(255, 128, 51, 0.32) transparent;
      position: absolute;
      left: 50%;
      top: -16px;
      transform: translateX(-50%);
      z-index: 1;
    }
    &::before{
      content: "";
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent #FFF8F3 transparent;
      position: absolute;
      left: 50%;
      top: -15px;
      transform: translateX(-50%);
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/components/share-with-friends.vue